import { render, staticRenderFns } from "./adminIndex.vue?vue&type=template&id=72760dfb&scoped=true"
import script from "./adminIndex.vue?vue&type=script&lang=js"
export * from "./adminIndex.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/admin/adminIndex.css?vue&type=style&index=0&id=72760dfb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72760dfb",
  null
  
)

export default component.exports